module.exports = __webpack_public_path__ + "img/zoom.43c32788.png";